export function getComponentValues(c1IdealValue, stageFp, stageQ, gain) {
  let c2IdealValue = c1IdealValue;
  let resistorRatio = computeResistorRatio(stageQ, gain);
  let rMultAvg = computeResistorMultiplierAverage(c1IdealValue, c2IdealValue, stageFp);
  let r1IdealValue = rMultAvg / Math.sqrt(resistorRatio);
  let r2IdealValue = rMultAvg * Math.sqrt(resistorRatio);

  return {
    c1IdealValue: c1IdealValue,
    c2IdealValue: c2IdealValue,
    r1IdealValue: r1IdealValue,
    r2IdealValue: r2IdealValue,
  };
}

function computeResistorRatio(stageQ, gain) {
  var a = 1;
  var b = 2 * (2 - gain) - 1 / (stageQ * stageQ);
  var d = (2 - gain) * (2 - gain);
  var result = (-b + Math.sqrt(b * b - 4 * a * d)) / (2 * a);
  return result;
}

function computeResistorMultiplierAverage(c1IdealValue, c2IdealValue, stageFp) {
  return 1 / (2 * Math.PI * stageFp * Math.sqrt(c1IdealValue * c2IdealValue));
}
